module.exports = `<!DOCTYPE html>

<html>
<head><meta http-equiv=Content-Type content="text/html; charset=UTF-8">
<style type="text/css">
</style>
</head>
<body>
<div style="top: 0px;margin-top: 10px; padding-bottom: 10px;text-align: justify; font-family: Quicksand;">
<p align="center">
    <strong>AVISO DE PRIVACIDAD</strong>
</p>
<p align="center">
    <strong>A3 CLOUD MICROSERVICES S.A.P.I. DE C.V.</strong>
</p>
<p>
    Este Aviso de privacidad tiene por objeto proporcionarle información de
    cómo tratamos los datos personales que recabamos por cualquier medio,
    incluyendo sitios, aplicaciones, comunicaciones presenciales o remotas,
    relacionadas con los servicios que ofrece A3 Cloud Microservices, S.A.P.I. de
    C.V. (en adelante “<strong>govo.legal</strong>”), así como
    nuestros esfuerzos por protegerlos, las opciones que tiene, para controlar
    sus datos personales y proteger su privacidad.
</p>
<p>
    Por lo tanto y observando lo establecido en la Ley Federal de Protección de
    Datos Personales en Posesión de los Particulares y su Reglamento, se
    informa que <strong>govo.legal</strong> funge
    como Responsable del tratamiento de sus datos personales cuyos datos
    generales son:
</p>
<p>
    Domicilio fiscal: Ignacio Allende 888, colonia Centro, Monterrey, Nuevo
    León CP 64000
</p>
<p>
    Domicilio de la oficina de privacidad: Av. San Jerónimo 310, Altreca
    Int.703, San Jerónimo, Monterrey Nuevo León, CP 64640.
</p>
<p>
    Teléfono de la oficina de privacidad: (0181)17681144
</p>
<p>
    Correo electrónico:
    <a href="mailto:contacto@a3microservices.com">
        contacto@a3microservices.com
    </a>
    .
</p>
<p>
Usted, al utilizar los servicios de <strong>govo.legal</strong> declara conocer y aceptar los términos y
    condiciones contenidas en este aviso de privacidad, y otorga de conformidad
    con lo dispuesto por los artículos 1803 del Código Civil Federal y 8,
    párrafo tercero de la Ley Federal de Protección de Datos Personales en
    Posesión de Particulares, expresamente su aceptación y consentimiento para
    que <strong>govo.legal</strong> use sus datos
    personales para las finalidades contenidas en este aviso.
</p>
<p>
    <strong>DEFINICIONES</strong>
</p>
<p>
    <strong></strong>
</p>
<p>
    <strong>DATOS PERSONALES. </strong>
    Cualquier información concerniente a una persona física identificada o
    identificable.
</p>
<p>
    <strong>TITULAR. </strong>
    La persona física mayor de edad <strong>(TITULAR)</strong> a quien
    identifica o corresponden los datos personales.
</p>
<p>
    <strong>RESPONSABLE.</strong>
    <strong>govo.legal</strong>
    que decide sobre el tratamiento de los datos personales.
</p>
<p>
    <strong>TRATAMIENTO.</strong>
    La obtención, uso (que incluye el acceso, manejo, aprovechamiento,
    transferencia o disposición de datos personales), divulgación o
    almacenamiento de datos personales por cualquier medio.
</p>
<p>
    <strong></strong>
</p>
<p>
    <strong>TRANSFERENCIA.</strong>
    Toda comunicación de datos realizada a persona distinta del responsable o
    encargado del tratamiento.
</p>
<p>
    <strong>DERECHOS ARCO. </strong>
    Derechos de acceso, rectificación, cancelación y oposición.
</p>
<p>
    <strong>CONSENTIMIENTO TÁCITO.</strong>
    Se entenderá que el titular, ha consentido en el tratamiento de los datos,
    cuando habiéndose puesto a su disposición el Aviso de Privacidad, no
    manifieste su oposición.
</p>
<p>
    <strong>DATOS PERSONALES QUE SE RECABAN </strong>
</p>
<p>
    <strong></strong>
</p>
<p>
Los datos personales que se tratarán por    <strong>govo.legal</strong> en la contratación y/o prestación de
    sus servicios, son:
</p>
<p>
    1) Nombre completo;
</p>
<p>
    2) Correo electrónico;
</p>
<p>
    3) Datos fiscales (nombre, denominación o razón social, registro federal de
    contribuyentes, domicilio fiscal);
</p>
<p>
    4) Teléfono (móvil y particular);
</p>
<p>
    5) Datos relacionados con la forma de pago de los servicios contratados;
</p>
<p>
    6) En caso de que el Titular haya determinado el uso de la firma
    electrónica avanzada como medio de autenticación o firmado de documentos
digitales para usar cualquier aplicativo o sistema de    <strong>govo.legal</strong>, adicionalmente se tendrá acceso:
</p>
<p>
    a. Al certificado digital correspondiente, emitido por autoridad
    certificadora en términos de lo dispuesto en el artículo 2, fracción IV de
    la Ley de Firma Electrónica Avanzada, de cuyo contenido se podrán obtener
    los siguientes atributos:
</p>
<p>
    i. Número de serie;
</p>
<p>
    ii. Autoridad certificadora que lo emitió;
</p>
<p>
    iii. Algoritmo de firma;
</p>
<p>
    iv. Vigencia;
</p>
<p>
    v. Nombre del titular del certificado digital;
</p>
<p>
    vi. Dirección de correo electrónico del titular del certificado digital;
</p>
<p>
    vii. Registro Federal de Contribuyentes;
</p>
<p>
    viii. Clave Única del Registro de Población (CURP) del titular del
    certificado digital;
</p>
<p>
    ix. Clave Pública, y
</p>
<p>
    x. Los demás requisitos que, en su caso, se establezcan en las
    disposiciones generales aplicables.
</p>
<p>
    7) En su caso, y únicamente para cuando el Titular de los datos personales
    haya determinado el uso de la validación de los elementos de seguridad de
documentos oficiales, mediante sistemas o aplicativos de    <strong> govo.legal</strong>, adicionalmente se podrá tener
    acceso a los datos contenidos en dichos documentos directamente del
    documento proporcionado por el Titular o bien mediante consulta a registros
    públicos o verificación en línea con autoridades oficiales.
</p>
<p>
    8) Finalmente se podrá obtener datos sobre la dirección IP y/o
    identificadores de su dispositivo, sistema operativo en uso, ubicación, la
    información de la red móvil, los datos de registro Web estándar, navegador
    que está utilizando y el tráfico hacia y desde los sitios para acceder a
    los servicios de A3 CLOUD MICROSERVICES, S.A.P.I. de C.V.
</p>
<p>
    <strong></strong>
</p>
<p>
    <strong></strong>
</p>
<p>
    <strong>FINALIDAD DEL TRATAMIENTO.</strong>
    Los datos personales serán utilizados, para prestar los servicios
    contratados con <strong>govo.legal</strong>,
    incluyendo:
</p>
<p>
    1. Integrar una base de datos de los usuarios clientes y con ello
otorgarles el acceso y uso de las soluciones tecnológicas de    <strong>govo.legal</strong>, así como demás
    servicios contratados.
</p>
<p>
    2. Validación de certificados digitales con las Autoridades Certificadoras
    emisoras, incluyendo el Servicio de Administración Tributaria.
</p>
<p>
    3. Verificación de los datos de identidad para la autenticación de los
usuarios en las soluciones tecnológicas de <strong>govo.legal</strong>, así como demás servicios contratados.
</p>
<p>
    4. Firmar mensajes de datos, así como documentos mediante el uso de medios
    electrónicos, incluyendo la utilización de certificados digitales efirma
    emitidos por el Servicio de Administración Tributaria, y cualquier otra
    autoridad certificadora reconocida como tal de conformidad con la
    legislación aplicable.
</p>
<p>
    <strong></strong>
</p>
<p>
    <strong>FORMAS DE RECABAR SUS DATOS PERSONALES.</strong>
    Para las actividades señaladas en el presente Aviso de Privacidad, podemos
    recabar sus datos personales de distintas formas, cuando usted nos los
    proporciona directamente de manera presencial o remota; cuando visita
    nuestro sitio de Internet o utiliza nuestros servicios en línea y cuando
    obtenemos información a través de otras fuentes, siempre y cuando estén
    permitidas por la ley.
</p>
<p>
    <strong></strong>
</p>
<p>
    <strong>USO DE (SSL). </strong>
    La seguridad y la confidencialidad de los datos personales, que los
Titulares proporcionen al contratar algún servicio de    <strong>govo.legal</strong> o comprar un
    producto en línea, estarán protegidos por un servidor seguro bajo el
    protocolo Secure Socket Layer (SSL), de tal forma que los datos se
    transmitirán encriptados, para asegurar su integridad. Para verificar que
se encuentra en un entorno protegido, asegúrese de que aparezca una    <strong>S</strong> en la barra de navegación del protocolo HTTP.
</p>
<p>
    Sin embargo y a pesar de contar cada día con mejor tecnología y
    herramientas más seguras y eficaces. La protección de los datos enviados a
    través de internet o cualquier medio electrónico, no se puede garantizar al
100%, por lo que una vez recibidos <strong>govo.legal</strong> hará lo pertinente para la salva guarda de
    la información proporcionada por el cliente.
</p>
<p>
    <strong>LIMITACIÓN O DIVULGACIÓN DE SUS DATOS PERSONALES. </strong>
    En cualquier momento, el Titular podrá limitar el uso o divulgación de sus
    datos personales, para ello deberá enviar un correo electrónico, dirigido a
    <a href="mailto:contacto@a3microservices.com">
        contacto@a3microservices.com
    </a>
    , solicitando la limitación del uso o divulgación de que se trate, donde
    podrá solicitar se le incluya en los listados de exclusión internos de no
    contactar para fines promocionales y mercado lógicos. Asimismo, podrá
    inscribirse en el registro público para evitar publicidad de la
    Procuraduría Federal del Consumidor (REPEP), accediendo a la siguiente
liga,    <a href="http://repep.profeco.gob.mx/">http://repep.profeco.gob.mx/</a>.
</p>
<p>
    <strong>PROCEDIMIENTO PARA HACER VALER LOS DERECHOS ARCO.</strong>
    Usted tiene derecho de acceder a sus datos personales, que poseemos y a los
    detalles del tratamiento de los mismos; es decir rectificarlos en caso de
    ser inexactos o incompletos, cancelarlos cuando considere que no, se
    requieren para alguno de los fines señalados en el presente Aviso de
    Privacidad o estén siendo utilizados, para fines no consentidos o haya
    finalizado la relación contractual o de servicio u oponerse al tratamiento
    de los mismos, para fines específicos.
</p>
<p>
    Los mecanismos que se han implementado para el ejercicio de dichos
    derechos, los cuales se conocen como derechos Arco mismos que se refieren a
    la rectificación, cancelación y oposición del Titular respecto al
    tratamiento de sus datos personales.
</p>
<p>
    <strong>1) </strong>
    El procedimiento inicia con la presentación de la solicitud respectiva a
    los derechos Arco, en el domicilio de nuestra Oficina de Privacidad o por
    correo electrónico a contacto@a3microservices.com, señalado al principio
    del presente Aviso de Privacidad.
</p>
<p>
    <strong>2) </strong>
    Su solicitud deberá contener la siguiente información:
</p>
<p>
    · Nombre del titular de los datos personales, domicilio o cualquier otro
    medio de contacto, documentos que acrediten su personalidad e identidad, la
    descripción clara y precisa de los datos personales, cualquier otro
    documento que facilite la localización de los datos.
</p>
<p>
    <strong>3) </strong>
    El plazo para atender su solicitud, es de 10 días.
</p>
<p>
    <strong>TRANSMISIÓN DE SUS DATOS PERSONALES.</strong>
</p>
<p>
    <strong>govo.legal</strong>
    no realiza transferencias a terceros de sus datos personales sin su
    consentimiento, salvo en los casos que tenga como único propósito cumplir
    con las finalidades señaladas en el presente aviso de privacidad, así como
    aquellas que están permitidas por disposiciones legales que incluyen
    peticiones de autoridades competentes.
</p>
<p>
    <strong>MODIFICACIONES AL AVISO DE PRIVACIDAD. </strong>
    Nos reservamos el derecho de efectuar en cualquier momento modificaciones o
    actualizaciones al presente Aviso de Privacidad, para la atención de
    novedades legislativas, políticas internas o nuevos requerimientos para la
    prestación u ofrecimiento de nuestros servicios o productos.
</p>
<p>
    Por lo que se obliga a mantener actualizado el presente Aviso, para su
    consulta. Esto con el fin de que<strong> el Titular</strong> se encuentre
    en posibilidad de ejercer sus derechos <strong>ARCO</strong> y de esta
    forma mantenerlo al tanto de cualquier modificación mediante aviso al
    último correo electrónico que nos haya proporcionado.
</p>
<p>
    <strong>USO DE COOKIES.</strong>
    <strong>govo.legal</strong>
    no usa cookies para recabar información sobre usted.
</p>
<p>
    <strong>USO DE WEB BEACONS.</strong>
    <strong>govo.legal</strong>
    no usa web beacons para recabar información sobre usted.
</p>
<p>
    Las partes expresan que el presente aviso, se regirá por las disposiciones
    legales aplicables en el Estado de Nuevo León en especial, por lo dispuesto
    en la Ley Federal de Protección de Datos Personales en Posesión de
    Particulares.
</p>
<p>
    Si usted considera que su derecho de protección de datos personales ha sido
    lacerado por alguna conducta de nuestros empleados o nuestra actuación o
    respuestas, presume que en el tratamiento de sus datos personales, existe
    alguna violación a las disposiciones previstas en la Ley Federal de
    Protección de Datos Personales en Posesión de los Particulares, podrá
    interponer la inconformidad o queja, correspondiente ante el Instituto
    Nacional de Acceso a la Información (INAI).
</p>
</div>
</body>
</html>
`;